import I18n from 'I18n';
import { getWeekLowerBound, getWeekUpperBound, getWeekdaysRange, isBefore } from './time';
import { eventLengthInDays } from './event';
export const getStartPosition = (dayOfWeek, hideWeekends) => {
  return getWeekdaysRange(hideWeekends, I18n.moment.locale()).indexOf(dayOfWeek);
};
export const getWeekDetails = ({
  hideWeekends,
  displayYear,
  displayDay,
  timezone
}) => {
  const visibleWeekStartDay = getWeekLowerBound(displayYear, displayDay, hideWeekends, timezone, I18n.moment.locale()).valueOf();
  const visibleWeekEndDay = getWeekUpperBound(displayYear, displayDay, hideWeekends, timezone, I18n.moment.locale()).valueOf();
  return {
    visibleWeekStartDay,
    visibleWeekEndDay
  };
};
export const getEventWeekDetails = ({
  displayDay,
  displayYear,
  dayOfWeek,
  start,
  end,
  timezone,
  hideWeekends
}) => {
  const {
    visibleWeekStartDay,
    visibleWeekEndDay
  } = getWeekDetails({
    hideWeekends,
    displayYear,
    displayDay,
    timezone
  });
  const startPosition = getStartPosition(dayOfWeek, hideWeekends);
  const visibleStart = isBefore(start, visibleWeekStartDay, timezone) ? visibleWeekStartDay : start;
  const visibleEnd = isBefore(end, visibleWeekEndDay, timezone) ? end : visibleWeekEndDay;
  return {
    visibleWeekStartDay,
    visibleWeekEndDay,
    visibleStart,
    visibleEnd,
    startPosition,
    lengthForWeek: eventLengthInDays({
      start: visibleStart,
      end: visibleEnd
    })
  };
};